import { ItemJob } from "../models/sales";

export const formatStorageBoxesFromOrder = (itemsJobs?: ItemJob[]) => {
  const storageBoxesInItemJob: string[] = [];

  if (itemsJobs && itemsJobs?.length > 0) {
    itemsJobs.forEach((itemJob) => {
      if (itemJob?.storageBoxes && itemJob?.storageBoxes?.length > 0) {
        const storageBox = itemJob?.storageBoxes[0];
        const isFind = storageBoxesInItemJob.find((inItemJob) => inItemJob === storageBox.number);

        if (!isFind && storageBox?.number) storageBoxesInItemJob.push(storageBox?.number);
      }
    });
  }

  return storageBoxesInItemJob && storageBoxesInItemJob?.length > 0
    ? storageBoxesInItemJob?.join(", ")
    : "";
};
